import GlobalError from '@components/layout/global-error.jsx';
import { useRouteError } from 'react-router-dom';

export default function GlobalErrorBoundary() {
  let error = useRouteError();
  return <GlobalError error={error} />;
}
